import type { Review, VideoTestimonial } from '../types/content';

export const reviews: Review[] = [
  {
    id: 'mimi',
    name: 'Mimi Peckham',
    course: 'Multiple HPP courses',
    quote:
      'Every course I’ve taken has helped me to be more comfortable using my guns. Maggie & Ken have an amazing ability to evaluate a person & help them to properly correct their skills.',
    rating: 5,
  },
  {
    id: 'debra',
    name: 'Debra Anguiano',
    course: 'Introduction to Defensive Handgun',
    quote:
      'I had an amazing time. I learned so much and instructors were great and knowledgeable. At the end of the day I felt comfortable in handling my hand gun.',
    rating: 5,
  },
  {
    id: 'shannon',
    name: 'Shannon Jagusch',
    course: 'Intuitive Defensive Shooting (2-day)',
    quote: 'Thank you so much for everything that you have taught me the past two days! You guys are great role models.',
    rating: 5,
  },
];

/** VIDEO SLOTS — drop in real student video testimonials. */
export const videoTestimonials: VideoTestimonial[] = [
  { id: 'v1', name: 'Student video testimonial', course: 'Multi-State CCW', slot: 'Video testimonial slot 1' },
  { id: 'v2', name: 'Student video testimonial', course: "Women's Defense Network", slot: 'Video testimonial slot 2' },
];
